import Vue from "vue";

export default {
    activityLog(perPage, page) {
        return Vue.http.get(`admin/activity-log?per_page=${perPage}&page=${page}`);
    }
}